var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinerHomepage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6349 0.720809H4.36515C2.35614 0.720809 0.727525 2.3344 0.727525 4.32486V11.6751C0.727525 13.6656 2.35615 15.2792 4.36515 15.2792H11.6349C13.6439 15.2792 15.2725 13.6656 15.2725 11.6751V4.32485C15.2725 2.3344 13.6439 0.720809 11.6349 0.720809ZM4.36515 0C1.95434 0 0 1.93631 0 4.32486V11.6751C0 14.0637 1.95435 16 4.36515 16H11.6349C14.0457 16 16 14.0637 16 11.6751V4.32485C16 1.9363 14.0457 0 11.6349 0H4.36515Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99944 13.0859C10.7993 13.0859 13.079 10.8145 13.079 8.00042C13.079 5.18629 10.7993 2.91497 7.99944 2.91497C5.1996 2.91497 2.91985 5.18629 2.91985 8.00042C2.91985 10.8145 5.1996 13.0859 7.99944 13.0859ZM7.99944 13.7147C11.1554 13.7147 13.7137 11.1563 13.7137 8.00042C13.7137 4.84451 11.1554 2.28613 7.99944 2.28613C4.84353 2.28613 2.28516 4.84451 2.28516 8.00042C2.28516 11.1563 4.84353 13.7147 7.99944 13.7147Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00084 5.25679C6.48588 5.25679 5.25776 6.4849 5.25776 7.99986C5.25776 9.51482 6.48588 10.7429 8.00084 10.7429C9.51579 10.7429 10.7439 9.51482 10.7439 7.99986C10.7439 6.4849 9.51579 5.25679 8.00084 5.25679ZM4.57227 7.99986C4.57227 6.10631 6.10729 4.57129 8.00084 4.57129C9.89438 4.57129 11.4294 6.10631 11.4294 7.99986C11.4294 9.89341 9.89438 11.4284 8.00084 11.4284C6.10729 11.4284 4.57227 9.89341 4.57227 7.99986Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3778 14.8569L1.14258 1.60828L1.62163 1.14258L14.8569 14.3912L14.3778 14.8569Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62219 14.8569L14.8574 1.60828L14.3784 1.14258L1.14314 14.3912L1.62219 14.8569Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinerHomepage);
export default __webpack_public_path__ + "res/media/miner-homepage.4d84501072ef5ed56f3feca530edf3ae.svg";
export { ForwardRef as ReactComponent };